/**
 * KAN-925: подписи аккаунта в переключателе: роль по-русски и буква аватара.
 */
const ROLE_LABELS: Record<string, string> = {
  OWNER: 'Владелец',
  USER: 'Оператор',
  MANAGER: 'Менеджер',
};

export function accountRoleLabel(role: string | null | undefined): string {
  return (role && ROLE_LABELS[role]) || '';
}

/** Первая буква имени (или email) для круглого аватара. */
export function accountInitial(name: string, email: string): string {
  return (name.trim() || email.trim() || '?').charAt(0).toUpperCase();
}
